import React from "react"
import Map from "./Map/Map";
import SearchBar from "./SearchBar/SearchBar";
import "./App.scss"
import log from './logger'
import {nearestMarkers} from "./utils";

const Fetch = window.fetch;

export default class App extends React.PureComponent {
  constructor(props) {
    super(props)

    this.state = {
      searchBarVisible: false,

      markers: [],

      home: undefined,
      nearestMarkers: undefined,
      activeMarker: undefined,
    }

    this.setHome = this.setHome.bind(this)
    this.setActiveMarker = this.setActiveMarker.bind(this)
    this.toggleSearchBar = this.toggleSearchBar.bind(this)
  }

  componentDidMount() {
    this.fetchMarkers().catch(console.error)
  }

  setHome(lat, lng) {
    log('setHome', lat, lng)
    this.setState(state => {
      const home = {lat, lng}
      const markers = nearestMarkers(home, state.markers)

      return {home, nearestMarkers: markers, activeMarker: markers[0]}
    })
  }

  setActiveMarker(marker) {
    log('setActiveMarker', marker)
    this.setState({activeMarker: marker})
  }

  async fetchMarkers() {
    const res = await Fetch('/markers.json')
    const markers = await res.json()
    const indexedMarkers = markers.map((m, id) => ({...m, ID: id}))
    log('markers loaded', indexedMarkers)
    this.setState({markers: indexedMarkers})
  }

  toggleSearchBar(){
    log('toggleSearchBar')
    this.setState(state => ({searchBarVisible: !state.searchBarVisible}))
  }

  render() {
    return (
      <div className="App">
        <div className={`SearchBarWrapper ${this.state.searchBarVisible ? 'expanded' : 'collapsed'}`}>
          <SearchBar
            setHome={this.setHome}
            setActiveMarker={this.setActiveMarker}
            activeMarker={this.state.activeMarker}
            markers={this.state.home ? this.state.nearestMarkers : this.state.markers}
            searchBarVisible={this.state.searchBarVisible}
            toggleSearchBar={this.toggleSearchBar}
          />
        </div>

        <div className="MapWrapper">
          <Map
            setActiveMarker={this.setActiveMarker}
            activeMarker={this.state.activeMarker}
            markers={this.state.markers}
          />
        </div>
      </div>
    )
  }
}
